const TprApiUrls = {
    GET: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/party/get`,
    GET_USER: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/get`,
    UPDATE_USER: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/update`,
    GET_USER_MENU_PRIVILEGES: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user-role/menu-privileges/get`,
  };
  
  export default TprApiUrls